export const THEME_DARK = "THEME_DARK";
export const THEME_LIGHT = "THEME_LIGHT";
